import React, { useMemo } from 'react';
import { useChallenge } from '@/queries';
import { createIconElement } from '@/lib/utils/createIconElement';
import IcProfile from '@/assets/icons/ic-profile.svg';
import IcCurrencyDollarCircle from '@/assets/icons/ic-currency-dollar-circle.svg';
import IcTag from '@/assets/icons/ic-tag.svg';
import styles from './ChallengeScore.module.css';

interface ChallengeScoreProps {
    className?: string;
}

export function ChallengeScore({ className }: ChallengeScoreProps) {
    const { communityStats } = useChallenge();

    const members = useMemo(() => {
        return communityStats?.total_members ?? 0;
    }, [communityStats]);

    const totalRevenue = useMemo(() => {
        const revenue = communityStats?.gv_total_revenue ?? 0;
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(revenue);
    }, [communityStats]);

    const products = useMemo(() => {
        return communityStats?.total_products_made ?? 0;
    }, [communityStats]);

    return (
        <div className={`${styles.scoreCard} ${className || ''}`}>
            {/* Members Card */}
            <div className={styles.statCard}>
                <div className={styles.iconWrapper}>{createIconElement(IcProfile, { className: styles.icon })}</div>
                <div className={styles.contentWrapper}>
                    <div className={styles.value}>{members}</div>
                    <div className={styles.label}>Members</div>
                </div>
            </div>

            {/* Total Revenue Card */}
            <div className={styles.statCard}>
                <div className={styles.iconWrapper}>
                    {createIconElement(IcCurrencyDollarCircle, { className: styles.icon })}
                </div>
                <div className={styles.contentWrapper}>
                    <div className={styles.value}>{totalRevenue}</div>
                    <div className={styles.label}>Total revenue</div>
                </div>
            </div>

            {/* Products Card */}
            <div className={styles.statCard}>
                <div className={styles.iconWrapper}>{createIconElement(IcTag, { className: styles.icon })}</div>
                <div className={styles.contentWrapper}>
                    <div className={styles.value}>{products}</div>
                    <div className={styles.label}>Products</div>
                </div>
            </div>
        </div>
    );
}
